import resetFields from './resetFields';

export default () => {
  const formModal = document.querySelector('.ShippingStatusModal__form');
  const errorText = document.querySelector('.ShippingStatusModal__sub-heading');
  const errorBlock = document.querySelector('.ShippingStatusModal__border-block');
  const modalClose = document.querySelectorAll('.ShippingStatusModal [data-close-modal]');

  // reset the modal anytime a user closes it
  modalClose.forEach((close) => {
    close.addEventListener('click', () => {
      errorText.innerHTML = 'Enter your order number to check its status.';
      resetFields();
    });
  });

  const removeLoader = () => {
    document.querySelector('.ShippingStatusModal__button-text').style.display = 'block';
    document.querySelector('.ShippingStatusModal__loader').style.display = 'none';
    document
      .querySelector('.ShippingStatusModal__button-text')
      .classList.remove('ShippingStatusModal__button-submitting');
  };

  const addLoader = () => {
    document.querySelector('.ShippingStatusModal__button-text').style.display = 'none';
    document.querySelector('.ShippingStatusModal__loader').style.display = 'flex';
    document.querySelector('.ShippingStatusModal__button-text').classList.add('ShippingStatusModal__button-submitting');
  };

  formModal.addEventListener('submit', (e) => {
    e.preventDefault();

    // display loader icon
    addLoader();

    // form input values
    const orderNumber = document.querySelector('.ShippingStatusModal__input-wrapper input[name="order_number"]').value;
    const email = document.querySelector('.ShippingStatusModal__input-wrapper input[name="zip"]').value;

    const requestData = {
      order_number: orderNumber,
      email: email,
    };

    const api_endpoint_shopify_order_status = window.location.host.includes('wndsr.dev')
      ? 'https://nestjs-service.wndsr.dev/shopify/orders/status'
      : 'https://nestjs-service.wndsr.io/shopify/orders/status';
    fetch(api_endpoint_shopify_order_status, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          errorText.innerHTML = 'Invalid Order Number or Email Address. Please Try Again.';
          errorBlock.classList.add('has-errors');
          throw new Error(`Error: ${response.status}`);
        }
      })
      .then((data) => {
        errorText.innerHTML = 'WE GOT YOUR ORDER! PLEASE WAIT... ';
        errorBlock.classList.remove('has-errors');
        window.location.href = data.order_status_url;
      })
      .catch((error) => {
        console.error('Error:', error);
        removeLoader();
      });
  });
};
